import React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';

import type { DeleteHandlerProps } from './types';
import { useDeleteHandlerWithConfirmation } from './useDeleteHandlerWithConfirmation';

const displayName = 'DeleteHandlerIconButton';
const testid = buildTestid(displayName);

function DeleteHandlerIconButton({
  handlerId,
  className = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteHandlerProps & IconButtonProps): React.JSX.Element {
  const deleteHandler = useDeleteHandlerWithConfirmation({ handlerId });

  return (
    <IconButton
      className={className}
      icon={<DeleteIcon />}
      kind="negative"
      variant="flat"
      {...testid(dataTestId)}
      {...props}
      onClick={deleteHandler}
    />
  );
}

export { DeleteHandlerIconButton };
